import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M642.077028,960.294599 C642.077028,785.018909 784.713713,642.382223 959.989403,642.382223 C1028.44653,642.382223 1090.43945,666.01371 1142.25916,703.103487 L702.798291,1142.56436 C665.708514,1090.74464 642.077028,1028.75173 642.077028,960.294599 L642.077028,960.294599 Z M1717.25668,128 L1792.284,203.027321 L1218.55813,776.647217 L776.342021,1218.86333 L202.722125,1792.5892 L127.694804,1717.56188 L411.484585,1433.87807 C384.673974,1416.60483 357.33351,1397.95397 329.357221,1376.75981 C199.225089,1275.34576 89.6512899,1139.59718 11.8687287,984.032056 L11.8687287,984.032056 L0,960.40057 L11.7627579,936.663112 C199.43703,559.089181 562.810875,324.469848 959.989403,324.469848 C1071.36471,324.469848 1180.30268,343.014737 1283.83614,379.468689 C1326.11849,392.715038 1369.35457,411.471868 1412.48468,432.877968 L1412.48468,432.877968 L1717.25668,128 Z M1595.83535,549.159718 C1723.0003,648.666291 1831.09051,783.355168 1908.44918,937.012816 L1908.44918,937.012816 L1920,960.32639 L1908.44918,983.533993 C1720.77491,1361.95569 1357.40107,1596.15114 960.010597,1596.15114 C848.741266,1596.15114 739.59135,1578.13611 635.739974,1541.04633 L635.739974,1541.04633 L612.4264,1532.56867 L878.625029,1266.26407 C904.693844,1273.36411 931.610425,1278.23877 960.010597,1278.23877 C1135.28629,1278.23877 1277.92297,1135.60208 1277.92297,960.32639 C1277.92297,931.926218 1273.04832,905.009637 1266.05424,878.940822 L1266.05424,878.940822 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconOffSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconOffSolid, _Component);

  var _super = _createSuper(IconOffSolid);

  function IconOffSolid() {
    _classCallCheck(this, IconOffSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconOffSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconOff",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconOffSolid.displayName = "IconOffSolid";
  return IconOffSolid;
}(Component);

IconOffSolid.glyphName = 'off';
IconOffSolid.variant = 'Solid';
IconOffSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconOffSolid;
export { IconOffSolid };